<template>
  <b-form-group
    label="Metin"
    label-for="cta_text"
  >
    <validation-provider
      #default="{ errors }"
      name="Metin"
      rules="required"
    >
      <b-form-input
        id="cta_text"
        v-model="dataItem.cta_text"
        placeholder="Metin"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'CtaText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
